import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "flex flex-1" }
const _hoisted_3 = { class: "flex items-center justify-between mb-2" }

import { ref, onMounted } from 'vue';
import { useSalesRepStore } from '@/store';
import { SalesRepInterface, PaginatedSalesRepParams } from '@/types';
import AddSalesRep from './AddSalesRep';

type PageEvent = {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
  sortField: string | ((item: Record<string, unknown>) => string) | undefined;
  sortOrder: 0 | 1 | -1 | null | undefined;
  filters: object;
  originalEvent: object;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SalesRep',
  setup(__props) {

const salesRepStore = useSalesRepStore();
const showAddSalesRep = ref(false);
const params = ref<PaginatedSalesRepParams>({
  page: 1,
  per_page: 10,
  active: null,
});
const activeOptions = [
  { label: 'All', value: null },
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
];

function openAddSalesRepModal() {
  showAddSalesRep.value = true;
}

function closeAddSalesRepModal() {
  showAddSalesRep.value = false;
}

async function init() {
  await salesRepStore.fetchPaginatedSalesReps(params.value);
}

onMounted(async () => {
  await init();
});

function createMenuModel(salesRep: SalesRepInterface) {
  return [
    {
      label: salesRep.active === 1 ? 'Deactivate' : 'Activate',
      command: async () => {
        await toggleSalesRepStatus(salesRep);
      },
    },
  ];
}

async function toggleSalesRepStatus(salesRep: SalesRepInterface) {
  const newStatus = salesRep.active ? 0 : 1;
  let updateSucceeded = true;

  await salesRepStore
    .updateSalesRep(salesRep.id, { active: newStatus })
    .catch((error: { status: number; data: { message: string } }) => {
      updateSucceeded = false;
      if (error.status === 422) {
        salesRepStore.doToast(`Failed to save Sales Rep: ${error.data.message}`, '', true);
      } else {
        salesRepStore.doToast(`An unknown error occurred`, '', true);
      }
    });

  if (updateSucceeded) {
    salesRepStore.doToast(`Sales Rep ${newStatus ? 'activated' : 'deactivated'} successfully`);
  }

  await salesRepStore.fetchPaginatedSalesReps(params.value);
}

async function onPageChange(event: PageEvent) {
  params.value.page = Math.floor(event.first / event.rows) + 1;
  params.value.per_page = event.rows;
  await init();
}

async function onFilterChange() {
  params.value.page = 1;
  await init();
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "flex justify-between items-center" }, [
        _createElementVNode("h2", { class: "text-lg font-semibold" }, "Sales Representatives")
      ], -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-medium pt-2 mr-1" }, "Filter by status:", -1)),
            _createVNode(_component_Dropdown, {
              modelValue: params.value.active,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.value.active) = $event)),
              options: activeOptions,
              "option-label": "label",
              "option-value": "value",
              class: "w-48",
              placeholder: "Select Status",
              onChange: onFilterChange
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_AppButton, {
          text: "Add Sales Rep",
          type: "primary",
          onClick: openAddSalesRepModal
        })
      ]),
      (showAddSalesRep.value)
        ? (_openBlock(), _createBlock(_unref(AddSalesRep), {
            key: 0,
            onCancel: closeAddSalesRepModal,
            onRefresh: init,
            onSave: _cache[1] || (_cache[1] = 
          async () => {
            closeAddSalesRepModal();
            await init();
          }
        )
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_DataTable, {
        value: _unref(salesRepStore).paginatedSalesReps,
        "total-records": _unref(salesRepStore).totalRecords,
        lazy: true,
        paginator: true,
        rows: params.value.per_page ?? 10,
        first: ((params.value.page ?? 1) - 1) * (params.value.per_page ?? 10),
        loading: _unref(salesRepStore).loading,
        "data-key": "id",
        "responsive-layout": "scroll",
        "paginator-template": "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
        "rows-per-page-options": [10, 20, 30],
        "loading-icon": "logo-spinner",
        onPage: onPageChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "display_name",
            header: "Name"
          }),
          _createVNode(_component_Column, {
            field: "active",
            header: "Active"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.active === 1 ? 'Yes' : 'No'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "actions",
            header: "Actions",
            "header-style": "width: 4em",
            class: "text-center"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_ActionMenu, {
                "menu-items": createMenuModel(data),
                icon: "more_horiz"
              }, null, 8, ["menu-items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "total-records", "rows", "first", "loading"])
    ]),
    _: 1
  }))
}
}

})